// extracted by mini-css-extract-plugin
module.exports = {"date":"employee-report_date_1lYJy","scrollableContent":"employee-report_scrollableContent_2EQjj","scrollableContainer":"employee-report_scrollableContainer_168VS"};